import { render, staticRenderFns } from "./LotesTabs.vue?vue&type=template&id=7f2066e3"
import script from "./LotesTabs.vue?vue&type=script&lang=js"
export * from "./LotesTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports